export default (function (_ref) {
  var request = _ref.request;
  return {
    nationalProductionAdd: function nationalProductionAdd(data) {
      return request({
        url: '/mng/nationalProduction/add',
        method: 'post',
        data: data
      });
    },
    nationalProductionModify: function nationalProductionModify(data) {
      return request({
        url: "/mng/nationalProduction/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    nationalProductionDel: function nationalProductionDel(id) {
      return request({
        url: "/mng/nationalProduction/".concat(id, "/del"),
        method: 'delete'
      });
    },
    nationalProductionQuery: function nationalProductionQuery(data) {
      return request({
        url: '/mng/nationalProduction/query',
        method: 'get',
        params: data
      });
    },
    nationalProductionDetail: function nationalProductionDetail(id) {
      return request({
        url: "/mng/nationalProduction/".concat(id, "/detail"),
        method: 'get'
      });
    },
    nationalProductionReport: function nationalProductionReport(params) {
      return request({
        url: "/mng/nationalProduction/report/byBreed",
        method: 'get',
        params: params
      });
    }
  };
});